import styled from '@emotion/styled';
import { Stack, Button } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Container = styled(Stack)`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.messageBox};
  width: fit-content;

  /* max-width는 페이지 렌더 폭에 맞춰 inline style로 주입된다 */
  border-radius: 8px;
  box-shadow: ${theme.elevation.xs};
`;

/**
 * 바깥은 가운데, 안쪽 블록은 왼쪽 정렬이다.
 * 한 줄이면 안쪽 블록이 글자 폭만큼만 차지해 가운데로 오고(버튼 이름이 더 길어
 * 박스가 넓어진 경우에도 균형이 잡힌다), 줄이 넘어가거나 엔터로 나눈 문구는
 * 블록이 폭을 채우면서 각 줄이 왼쪽에 남아 가독성이 유지된다.
 */
export const MessageText = styled.span`
  display: inline-block;
  max-width: 100%;
  text-align: left;

  /* pre-wrap: 작성자가 입력한 줄바꿈·빈 줄·들여쓰기를 그대로 보존한다 */
  white-space: pre-wrap;
  word-break: break-word;
`;

export const MessageBoxButton = styled(Button)`
  &:hover {
    opacity: 0.5;
  }
`;
